<template>
  <div class="map-control-switch leaflet-bottom" style="margin-bottom: 50px;width: 160px;height: 36px;line-height: 36px;padding:10px 0 0 12px;color: #333333;font-size: 12px">
      <el-radio v-model="dgValue" :label="address" @click.native.prevent="change">{{title }}</el-radio>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import PopoverSelect from './popover-select';

const HOST = process.env.VUE_APP_LAYER_HOST2;

export default {
  components: {
    PopoverSelect
  },
  props: ['currentZoom'],
  data() {
    return {
        show: false,
        title: '等高线图层',
        dgValue: `${HOST}/geoserver/gwc/service/tms/1.0.0/dx:denggaoxian@Dx_EPSG:3857@png/{z}/{x}/{y}.png`,
        address: `${HOST}/geoserver/gwc/service/tms/1.0.0/dx:denggaoxian@Dx_EPSG:3857@png/{z}/{x}/{y}.png`,
        demc: `${HOST}/geoserver/gwc/service/tms/1.0.0/dx:demC@Dx_EPSG:3857@png/{z}/{x}/{y}.png`
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    zoomIndex(){
      return this.currentZoom;
    }
  },
  mounted() {
    this.$nextTick(() => {

    });
  },
  watch: {
    zoomIndex: {
      handler: function(newValue, oldValue) {
        // console.log(newValue);
        if(newValue >= 12 && this.dgValue){
          this.dgValue = this.address;
        }else{
          this.dgValue = null;
        }
        this.$emit("drawDgLayer",{ contourC:this.dgValue,demc:this.demc});
      },
      deep: true,
      immediate: true
    }
  },
  beforeDestroy() {
  },
  methods: {
    change(){
      if(this.dgValue){
        this.dgValue = null;
      }else{
        this.dgValue = this.address;
      }

      this.$emit("drawDgLayer", { contourC:this.dgValue,demc:this.demc});
    }
  }
};
</script>

<style lang="less" scope>
.map-control-switch {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 1px;
  font-size: 12px;
  display: flex;
  overflow: hidden;
    margin-bottom:60px;

  > span {
    // &:first-child {
    .el-link {
      border: 0;
    }
    // }
  }

  .el-link {
    padding: 7px 10px;
    border-left: 1px solid #ccc;

    &:hover:after {
      border: 0;
    }

    &:hover {
      .el-link--inner {
        color: @blue;
      }
    }

    .el-link--inner {
      font-size: 12px;
      color: #000;
    }
  }

  .color-simple-img {
    position: fixed;
    bottom: 30px;
    left: 4px;
    background-color: #c8e0f5;
    border-radius: 10px;

    .el-link {
      width: 100%;
      box-sizing: border-box;
      .el-link--inner {
        color: #3e3e3e;
      }
    }
  }

  > .el-checkbox-group {
    &:first-child {
      .el-checkbox-button__inner {
        border-radius: 10px;
      }
    }

    .el-checkbox-button {
      &.is-checked {
        .el-checkbox-button__inner {
          background: #d9e6f3;
          color: @blue;
        }
      }
      .el-checkbox-button__inner {
        background-color: #c8e0f5;
        border: 0;
        // border-left: 1px solid #e3e3e3;
      }
    }

    // .el-checkbox-button__inner {
    //   color: #ccc;

    //   &:hover {
    //     color: #fff;
    //   }
    // }
  }
  .icon-container {
    padding: 8px;
    i {
      display: inline-block;
      width: 16px;
      height: 16px;
      font-size: 16px;
    }
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
    }
    &:hover {
      background: linear-gradient(180deg, #3cd4e2, #738de1);
      i {
        color: #fff;
      }
    }
  }
}
</style>
